import PropTypes from 'prop-types';
import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../../organisms/Layout/Layout';

// renamed to match Sanity schema
import { renderPageSections } from '../renderPageSections';
import FormPageBanner from '../../organisms/FormPageBanner/FormPageBanner';

const FormPage = ({ data, location: { href } }) => {
  // unpublished pages return null data
  if (!data || data.sanityPage === null) {
    return null;
  }
  const pageProps = {
    id: data.sanityFormPage._id,
    metadata: { ...data.sanityFormPage._rawRoute, href },
    heroBanner: data.sanityFormPage._rawHeroBanner,
    sections: data.sanityFormPage._rawSections,
  };

  return (
    <Layout menuColor="gray" sanityId={pageProps.id} {...pageProps.metadata}>
      <FormPageBanner {...pageProps.heroBanner} />
      {renderPageSections(pageProps.sections)}
    </Layout>
  );
};

FormPage.propTypes = {
  data: PropTypes.shape({ sanityFormPage: {}, sanityPage: {} }),
  location: PropTypes.shape({ href: PropTypes.string }),
};

FormPage.defaultProps = {
  data: {},
  location: { href: '' },
};

export default FormPage;

export const query = graphql`
  query($slug: String) {
    sanityFormPage(
      route: { enabled: { eq: true }, slug: { current: { eq: $slug } } }
    ) {
      _id
      _rawRoute(resolveReferences: { maxDepth: 100 })
      _rawHeroBanner(resolveReferences: { maxDepth: 100 })
      _rawSections(resolveReferences: { maxDepth: 100 })
    }
  }
`;
